export default function truncateLeft(string: string, size: number): string {
  if (string.length > size) {
    if (size < 3) {
      return string.slice(-size);
    }
    return `...${string.slice(-size + 3)}`;
  }
  return string;
}
